// Pure decision logic for the email-verification onboarding modal/banner.
// No side effects, no React — easy to unit-test. The component renders based on
// these and never grants the free video itself.

export const DISMISS_KEY = 'emailVerifyDismissedAt';
export const DISMISS_WINDOW_MS = 24 * 60 * 60 * 1000; // 24 h

/**
 * Whether the blocking onboarding modal should be shown.
 * Hidden when: not authenticated, email already verified, free video already
 * claimed, or dismissed within the last 24 h.
 */
export function shouldShowVerifyModal({ isAuthenticated, user, freeTrialClaimed, dismissedAt, now = Date.now() }) {
  if (!isAuthenticated || !user) return false;
  if (user.email_verified === true) return false;     // already verified
  if (freeTrialClaimed) return false;                 // already claimed the free video
  if (dismissedAt && now - dismissedAt < DISMISS_WINDOW_MS) return false; // recently dismissed
  return true;
}

/**
 * Whether the non-blocking fallback banner should be shown — i.e. the user is
 * still unverified and un-claimed, but dismissed the modal within the last 24 h.
 */
export function shouldShowVerifyBanner({ isAuthenticated, user, freeTrialClaimed, dismissedAt, now = Date.now() }) {
  if (!isAuthenticated || !user) return false;
  if (user.email_verified === true) return false;
  if (freeTrialClaimed) return false;
  return Boolean(dismissedAt) && now - dismissedAt < DISMISS_WINDOW_MS;
}
